import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";
import CreatableSelect from 'react-select/creatable';

import { CardAtividade, Container } from "./styles";
import api from "~/services/api";

function DocumentosList({ defaultData, setter }) {
  const paginaPad = [
    { item: 1, id: 0, numeracao: "01", idsPessoas: [], idsTestemunhas: [] },
  ];
  const [pessoas, setPessoas] = useState([]);
  const [paginas, setPaginas] = useState([]);

  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/gestaodocumentos/gestaodocumentos/pessoas").then((r) => {
      let lista = [];

      for (const item of r?.data) {
        lista.push({ value: item?.id, label: item?.nome, color: "#00B8D9", idPessoa: item?.id, idTestemunha: item?.id, id: 0 });
      }

      setPessoas(lista);
    });
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aPaginas = [];
          let count = 1;
          for (const item of defaultData) {
            let listaPessoas = [];
            for (const itemPessoa of item?.pessoas) {
              listaPessoas.push({
                id: itemPessoa?.id,
                idPessoa: itemPessoa?.idPessoa,
                value: itemPessoa?.idPessoa,
                label: itemPessoa?.pessoa?.nome,
              });
            }

            let listaTestemunhas = [];
            for (const itemTestemunha of item?.testemunhas) {
              listaTestemunhas.push({
                id: itemTestemunha?.id,
                idTestemunha: itemTestemunha?.idTestemunha,
                value: itemTestemunha?.idTestemunha,
                label: itemTestemunha?.testemunha?.nome,
              });
            }

            aPaginas.push({ count, id: item?.id, numeracao: item?.numero, idsPessoas: listaPessoas, idsTestemunhas: listaTestemunhas });

            count++;
          }

          setPaginas(aPaginas);
          setter(aPaginas);
        }
      } else {
        if (!(edit && editShow)) {
          setPaginas(paginaPad);
          setter(paginaPad);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    setter(paginas);
  }, [paginas]);

  function handleAdd() {
    setPaginas((prev) => [...prev, { item: (paginas?.length > 0 ? paginas[paginas?.length - 1]?.item + 1 : 1), id: 0, numeracao: "01", idsPessoas: [], idsTestemunhas: [] }]);
  }

  function handleRemove(index) {
    setPaginas((prev) => {
      const newPrev = [...prev];

      newPrev.splice(index, 1);

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Páginas *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAdd}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      <CardAtividade>
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="colcsa w1">
              <div className="top-header">
                -
              </div>
            </div>
            <div className="colcsa w1">
              <p className="titulo">Numeração <span>*</span></p>
            </div>
            <div className="colcsa w5">
              <p className="titulo">Pessoas <span>*</span></p>
            </div>
            <div className="colcsa w5">
              <p className="titulo">Testemunhas</p>
            </div>
          </div>
        </div>
        {paginas?.map((itemData, index) => (
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <div className="colcsa w1">
                <div className="top-header">
                  <div onClick={(e) => { handleRemove(index) }} className="icon-button material-icons">delete</div>
                </div>
              </div>
              <div className="colcsa w1">
                <Input
                  name="numeracao"
                  required="true"
                  min="1"
                  value={itemData?.numeracao}
                  onChange={(e) => {
                    const v = e.currentTarget.value || 0;
                    setPaginas((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].numeracao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="colcsa w5">
                <CreatableSelect
                  isClearable
                  isMulti
                  options={pessoas}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  name="idsPessoas"
                  placeholder="Pessoas"
                  value={itemData?.idsPessoas}
                  onChange={(e) => {
                    setPaginas((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].idsPessoas = e;

                      return newPrev;
                    });
                  }}
                />
              </div>
              <div className="colcsa w5">
                <CreatableSelect
                  isClearable
                  isMulti
                  options={pessoas}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  name="idsTestemunhas"
                  placeholder="Testemunhas"
                  value={itemData?.idsTestemunhas}
                  onChange={(e) => {
                    setPaginas((prev) => {
                      let newPrev = [...prev];

                      newPrev[index].idsTestemunhas = e;

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default DocumentosList;
